// extracted by mini-css-extract-plugin
module.exports = {"tab":"CategoryCarousel_tab__TtXp0","tabActive":"CategoryCarousel_tabActive__u9sOC"};